import { Form, Skeleton } from "antd"
import { observer } from "mobx-react"
import { useEffect, useLayoutEffect, useRef, Suspense } from "react"
import "./App.less"
import {
  RetirementGuide,
  AppFormBOO,
  // Background,
  // Benefits,
  // Calculator,
  Disclaimer,
  Faq,
  Footer,
  Glossary,
  // Header,
  // IncomePlan,
  KeyTerms,
  PlanWorks,
  QuoteModal,
  Recommended,
  Steps,
  TalkToExpertModal,
  VideoModal,
  WhatIs,
  WhyUs,
  WhyUsHeader,
  SuitabilityModal,
  ClaimModal,
  // ExtraHeader,
  NriModal,
  RemoteHandOverAppForm
} from "./Components"
import Header from "./Components/Header/Header"
import Background from "./Components/GuaranteedIncome/Background"
import IncomePlan from "./Components/GuaranteedIncome/IncomePlan"
import Benefits from "./Components/GuaranteedIncome/Benefits"
import Calculator from "./Components/GuaranteedIncome/Calculator"
import {
  QuoteAPI,
  UserInput,
  UserInputReqJSON,
  QUOTEPDFAPI
} from "./Components/QuoteScreen/QuoteAPI"
import { DataLayerFn, ipAPI, leadWSAPI } from "./Configs/API"
import AppStore from "./Configs/Store"
import FormStore from "./Configs/Store/forms"
import { scrollPatch, CreateReactCookie, HideLandingLoader } from "./Components/Common/CommonFunctions"
import CommonStore from "./Configs/Store/common"
import BenefitHeadText from "./Components/Common/GenericComponenetHeader"
import BenefitStore from "./Configs/Store/benefit"
import JSON from "./Configs/JSON/Benefits.json"
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary"
import { ageValidation } from "./Configs/Validator/FormValidations"
import { isOldJourney } from "@ipru-common/utils/CommonFunctions.js"
import { GlobalProvider } from "@ipru-common/context/GlobalContext";

const SkeletonLoader = ({ children }) => {
  return <Skeleton active />
}

const App = observer(() => {
  const [calcFormRef] = Form.useForm()
  const [quoteFormRef] = Form.useForm()
  const [extraCardFormRef] = Form.useForm()

  const faq = useRef(null)
  const plan = useRef(null)
  const calculator = useRef(null)
  let employeeRedirectFlag = false

  useLayoutEffect(() => {
    const handleResize = (e) => {
      const width = window.innerWidth
      const height = window.innerHeight
      var isLocalHost = window.location.hostname === "localhost"
      AppStore.setWindowWidth(width)
      AppStore.setWindowHeight(height)
      AppStore.setLocalHost(isLocalHost)
      if (width < 1021) {
        AppStore.setDevice(0)
      } else {
        AppStore.setDevice(1)
      }
      if (!AppStore.depTesting) {
        console.log = () => { }
        console.info = () => { }
      }

      console.log(`Device=${AppStore.device === 0 ? "Mobile" : "PC"}, State=${AppStore.device}, Width=${width}, Height=${height}`)
    }

    const scrollPast = async (e) => {
      // if (isOldJourney()) {
        var elementTarget = document.getElementsByClassName("GuaranteedIncome_Background")[0]
        if (elementTarget !== undefined) {
          if (window.scrollY > elementTarget.offsetTop + elementTarget.offsetHeight) {
            AppStore.setmainFooter(true)
          } else {
            AppStore.setmainFooter(false)
          }
        }
      // }
    }

    handleResize()
    window.addEventListener("resize", handleResize, { passive: true })
    window.addEventListener("scroll", scrollPast, { passive: true })

    return () => {
      window.removeEventListener("resize", handleResize)
      window.removeEventListener("scroll", scrollPast)
    }
  }, [])

  useEffect(() => {
    var MAIN_URL = window.location.href
    var URL_OBJ = new URL(MAIN_URL)
    var personaType = URL_OBJ.searchParams.get("persona")
    if (AppStore.appLoaded) {
      var EmptyScript = window.scriptsLoaded
      var isResume = AppStore.isResumeJourney
      var isStepTrue = new URL(window.location.href).searchParams.get("Step") === "true"
      // console.info("Header State", EmptyScript)
      if (!EmptyScript) {
        const collectIp = async () => {
          const ip = await ipAPI()
          console.info("IP :", ip)
          window.ipAddress = ip["origin"]
          localStorage.recent_product = "GPP_dynamic"
        }

        if (!isStepTrue) {
          setTimeout(HideLandingLoader, isResume ? 2500 : 1000)
        }
        collectIp()
        PersonaVerfication()
        MessageListener()
        DataLayerFn("Landed||Calculator-Landing page", FormStore, "", "", "", "")
        // setTimeout(() => {
        //   if (typeof window.hj === "function") {
        //     if (personaType === "GPPDA") {
        //       window.hj("event", "gppda_lp")
        //     } else {
        //       window.hj("event", "gppia_lp")
        //     }
        //   }
        // }, 1000)

        const fetchURLParams = async () => {
          var MAIN_URL = window.location.href
          var URL_OBJ = new URL(MAIN_URL)
          employeeRedirectFlag = URL_OBJ.searchParams.get("employeeRedirect")
        }

        fetchURLParams()

        if (employeeRedirectFlag == "true") {
          FormStore.setproccedModal_GroupEmpModal(true)
        }

        window.scriptsLoaded = true
      }
    }
  }, [AppStore.appLoaded])

  const PersonaVerfication = () => {
    var MAIN_URL = window.location.href
    var URL_OBJ = new URL(MAIN_URL)
    var personaType = URL_OBJ.searchParams.get("persona")
    var tempTypeVal = "GPPIA"
    var tempTypeVal_N = "0"
    var isPersonaValid = true
    var tempNPS = "N"
    var tempQuoteTab = "0"
    var tempQuotePension = "Me"
    var tempUserInputPension = "wantMe"
    var tempPrdId = "I14"
    if (personaType) {
      if (personaType === "GPPDA") {
        tempTypeVal = "GPPDA"
        tempTypeVal_N = "1"
        isPersonaValid = true
        tempQuoteTab = "1"
        tempPrdId = "I14"
        tempQuotePension = "Me_&_Nominee"
        tempUserInputPension = "wantMenominee"
      } else if (personaType === "GPPIA") {
        tempTypeVal = "GPPIA"
        tempTypeVal_N = "0"
        isPersonaValid = true
        tempPrdId = "I13"
      } else if (personaType === "GPPIANPS") {
        tempTypeVal = "GPPIANPS"
        tempTypeVal_N = "2"
        tempNPS = "Y"
        isPersonaValid = true
        tempQuotePension = "NPS_family_Income"
        tempUserInputPension = "wantNfc"
        tempPrdId = "I13"
      } else {
        isPersonaValid = false
      }
    } else {
      isPersonaValid = false
    }
    //debugger

    if (isPersonaValid) {
      // Always True
      calcFormRef.setFieldsValue({ calcNps: tempNPS })
      FormStore.setQuoteNPS(tempNPS)
      UserInput("NPS_Flag", "", tempNPS === "Y" ? "Yes" : "No")

      FormStore.setQuoteFormTab(tempQuoteTab)
      CommonStore.setplanWorksTab(tempTypeVal_N)

      FormStore.setQuotePension(tempQuotePension)
      UserInput("PensionFor", "", tempUserInputPension)

      FormStore.setCalcType(tempTypeVal)
      UserInput("calcType", "key", tempTypeVal)

      FormStore.setPersonaValidity(isPersonaValid)
      UserInput("productId", "", tempPrdId)
    } else {
      FormStore.setPersonaValidity(false)
    }
    console.info("Persona Type :", tempPrdId, FormStore.quote_formTab, window.UserInput.productId)
    localStorage.recent_product = tempPrdId === "I14" ? "GPP_DA_dynamic" : "GPP_dynamic"
  }

  const QuoteAPIFn = async () => {
    FormStore.setQuoteCardLoader(true)
    let mockFormStoreRef
    let mockQuoteFormRef
    if (
      (FormStore.annuity == "DeferredAnnuity" || FormStore.quote_formTab == 1) &&
      ((FormStore.calc_age <= 52 && FormStore.quote_RecAnnuityFreq < 10) ||
        (FormStore.calc_age <= 55 && FormStore.quote_RecAnnuityFreq < 7) ||
        (FormStore.calc_age <= 57 && FormStore.quote_RecAnnuityFreq < 5) ||
        (FormStore.calc_age <= 60 && FormStore.quote_RecAnnuityFreq < 3))
    ) {
      mockQuoteFormRef = { ...quoteFormRef.getFieldsValue() }
      let defaultAnnunityYears = 10
      if (FormStore.calc_age <= 52) defaultAnnunityYears = 10
      else if (FormStore.calc_age <= 55) defaultAnnunityYears = 7
      else if (FormStore.calc_age <= 57) defaultAnnunityYears = 5
      else defaultAnnunityYears = 3
      console.log("mock api parametrs", defaultAnnunityYears)
      mockQuoteFormRef.RecAnnuityFreq = defaultAnnunityYears
      mockFormStoreRef = { ...FormStore }
      mockFormStoreRef.quote_RecAnnuityFreq = defaultAnnunityYears
      let mockApiResponse = await QuoteAPI(mockFormStoreRef, calcFormRef, mockQuoteFormRef, false)

      let mockPrevKey = FormStore.quote_PlanSelected
      let mockFinalResult = await mockApiResponse.filter((x) => x.value !== 0)
      let mockPrevSelect = await mockFinalResult.findIndex((x) => x.key === mockPrevKey)
      let mockReqKey = mockPrevSelect === -1 ? 0 : mockPrevSelect
      if (mockFinalResult.length > 0) {
        let mockIntialObj = mockFinalResult[mockReqKey]
        FormStore.setQuoteMocKRecAnRate(mockIntialObj["pension"])
      }
    }
    var response = await QuoteAPI(FormStore, calcFormRef, quoteFormRef)
    // console.log("Plans Loaded", response)

    var prevKey = FormStore.quote_PlanSelected
    var finalResult = await response.filter((x) => x.value !== 0)
    var prevSelect = await finalResult.findIndex((x) => x.key === prevKey)
    var reqKey = FormStore.quote_formTab == 1 && prevSelect == -1 && FormStore.quote_Pension == "Me_&_Nominee" ? 1 : prevSelect == -1 ? 0 : prevSelect
    console.log("mock api paramets", prevSelect, reqKey)
    // var finalResult = [...response]
    if (finalResult.length > 0) {
      var initalObj = finalResult[reqKey]
      var initialSelect = initalObj["key"]
      var initialPayoutOption = initalObj["payoutOption"]
      var initialValue = initalObj["value"]
      var totalPension = initalObj["totalPension"]
      var disabled = initalObj["disabled"]
      console.log("Plans Loaded", finalResult)
      FormStore.setQuoteCardList(finalResult)
      if (!disabled) {
        FormStore.setPlanSelected(initialSelect)
        FormStore.setPlanSelectedObj(initalObj)
        FormStore.setTotalPension(totalPension)
        FormStore.setApiValue(initialValue)
        UserInput("PayoutOptions", "", initialPayoutOption)
        UserInputReqJSON("ProductDetails", "Product", "AnnuityOption", initialPayoutOption)
        UserInput("IncomeBenefit", "", initialValue)
      } else {
        FormStore.setPlanSelected(-1)
        FormStore.setPlanSelectedObj({})
        FormStore.setTotalPension(0)
        UserInput("PayoutOptions", "", "")
        UserInputReqJSON("ProductDetails", "Product", "AnnuityOption", "")
        UserInput("IncomeBenefit", "", "")
      }
    } else {
      FormStore.setQuoteCardList([])
      UserInput("PayoutOptions", "", "")
      UserInputReqJSON("ProductDetails", "Product", "AnnuityOption", "")
      UserInput("IncomeBenefit", "", "")
    }
    FormStore.setQuoteCardLoader(false)
    setTimeout(() => {
      CreateReactCookie()
    }, 1000)
  }
  async function calculateAge(value) {
    var min = calcFormRef.getFieldValue("buyingFor") === "Child" || calcFormRef.getFieldValue("buyingFor") === "Grandchild" ? (FormStore.proccedModal_wantIncomePeriod === "No" ? 7 : 0) : 18
    var max = 60
    var flag = await ageValidation(value, min, max)

    await FormStore.setCalcAge(flag.age)

    UserInput("age", "", flag.age)
    if (flag.valid && Math.sign(flag.age) !== -1) {
      calcFormRef.setFields([
        {
          name: "ageItem",
          errors: [],
        },
      ])
    } else if (flag.age === -1 || flag.age === -2) {
      calcFormRef.setFields([
        {
          name: "ageItem",
          errors: [flag.errorMsg],
        },
      ])
    }
  }
  const MessageListener = () => {
    window.onmessage = (e) => {
      var SuitParent = e.data.SuitParent
      var SuitDataLayer = e.data.DataLayer
      var OptionalLead = e.data.OptionalLead
      var EKYCDetails = e.data.EKYCDetails

      if (SuitParent || SuitDataLayer || OptionalLead) {
        console.info("onMessage :", e.data)
      }

      // Suitabiltiy
      if (SuitParent) {
        if (SuitParent["closeSuitability"]) {
          FormStore.setSuitabilityModal(false)
          if (!FormStore.quote_modal) {
            // Patch Scroll Issue Only In Landing Page
            scrollPatch("auto")
          }
          console.info("Window Closed", SuitParent)
        } else {
          var element = document.querySelector(".SuitabilityModalRoot .ant-modal-content")
          if (element) {
            console.info("Message :", SuitParent)
            element.style.height = SuitParent?.height ? `calc(${SuitParent.height + 80}px)` : "min(938px)"
          }
        }
        if (SuitParent["fireLeadWS"]) {
          const leadRes = leadWSAPI(FormStore, SuitParent["SuitabilityCheckBox"])
        }
      }

      // Suitabiltiy Data Layer
      if (SuitDataLayer) {
        DataLayerFn(`${SuitDataLayer["eventName"]} || ${SuitDataLayer["sectionName"]}`, FormStore, "", SuitDataLayer["buttonText"], SuitDataLayer["optionSelected"], {
          SuitabilityCalculation: SuitDataLayer["SuitabilityCalculation"],
        })
      }

      // Optional Lead
      if (OptionalLead) {
        var EmailVal = OptionalLead["emailItem"]
        var MobileVal = OptionalLead["mobileItem"]
        if (EmailVal && MobileVal) {
          FormStore.setOptionalLead(false)
          FormStore.setCalcEmail(EmailVal)
          FormStore.setCalcPhone(MobileVal)
          calcFormRef.setFieldsValue({ emailItem: EmailVal })
          calcFormRef.setFieldsValue({ mobileItem: MobileVal })
          UserInput("EmailId", "", EmailVal)
          UserInput("MobileNo", "", MobileVal)
          const leadRes = leadWSAPI(FormStore)
          DataLayerFn("OptionalLead_Continue||Calculator-QuoteScreen|Optional Lead Popup", FormStore, "", "Continue", "", "")
          DataLayerOptionEvent()
          setTimeout(() => {
            window.ReStructurePdtS("add")
            window.OpenSuitabilityPop()
            window.LoadAppFormFiles = true
            window.isAppFormLoaded = true // Not an ICICI variable
            window.isAppFormLanded = true
            FormStore.setQuoteModalLoader(false)
          }, 150)
        }
      }

      if (EKYCDetails) {
        console.info("onMessage:", e.data)
        const updatedDOB = e.data.EKYCDetails.updatedDOB
        const updatedGender = e.data.EKYCDetails.updatedGender
        const isLandingBackTrue = e.data.EKYCDetails.updateLanding
        if (window.UserInput.dob !== updatedDOB) {
          console.log("Updating Lead dob with EKYC DOB")
          window.UserInput.dob = updatedDOB
          FormStore.setCalcDob(updatedDOB)
          calculateAge(updatedDOB)
          calcFormRef.setFieldsValue({ ageItem: updatedDOB })
        }
        if (window.UserInput.gender !== updatedGender) {
          console.log("Updating Lead gender with EKYC gender")
          window.UserInput.gender = updatedGender
          FormStore.setCalcGender(updatedGender)
          calcFormRef.setFieldsValue({ gender: updatedGender })
        }

        setTimeout(() => {
          if (isLandingBackTrue) {
            try {
              console.log("Navigating to Landing page from EKYC modal")
              const backBtn = document.querySelector(".BackText")
              if (backBtn) {
                backBtn.click()
              }
            } catch (e) {
              console.error("EKYC error from gift LT", e)
            }
          } else {
            console.log("Calling Quote API from EKYC modal", UserInput.gender, UserInput.dob)
            QuoteAPIFn()
          }
        }, 1000)
      }
    }
  }

  const DataLayerOptionEvent = () => {
    var Email = window.ReactOptionLead_Email
    var Mobile = window.ReactOptionLead_Mobile
    if (!Email && !Mobile) {
      DataLayerFn("LeadSubmitted_MandatoryPopUp||Calculator-QuoteScreen|Mandatory Popup", FormStore, "", "", "", "")
    } else if (!Email) {
      DataLayerFn("EmailSubmitted_MandatoryPopUp||Calculator-QuoteScreen|Mandatory Popup", FormStore, "", "", "", "")
    } else if (!Mobile) {
      DataLayerFn("LeadSubmitted_Mobile_MandatoryPopUp||Calculator-QuoteScreen|Mandatory Popup", FormStore, "", "", "", "")
    }
  }

  const handleBack = () => {
    AppStore.showRemoteHandOverAppForm = false
  }

  return (
    <>
      <GlobalProvider >
        {AppStore.showRemoteHandOverAppForm && !isOldJourney() ? (
          <>
            <Header type={0} />
            <Suspense fallback={<SkeletonLoader />}>
              <RemoteHandOverAppForm onBackPress={handleBack} />
            </Suspense>
            <Suspense fallback={<SkeletonLoader />}>
              <TalkToExpertModal />
            </Suspense>
          </>
        ) : (
          <div className="LandingPage_Root">
            <h1 style={{ display: "none" }}> ICICI Life Guaranteed Pension Plan </h1>
            {/* <ExtraHeader /> */}
            <Header />
            <Background>
              <div className="IncomeMain">
                <div className="mobileOnly">
                  <BenefitHeadText
                    content={JSON.BHTTitleText}
                    icon={false}
                    onClick={() => {
                      BenefitStore.setAddBenefitModal(true)
                      DataLayerFn("OnlineBenefits_PopupOpen||Calculator-Landing page|Online Benefits", FormStore, "", "Buy online & get up to 2% Additional Benefit~", "", "")
                    }}
                  />
                </div>
                <div className="IncomeRoot">
                  <IncomePlan />
                  <Benefits />
                </div>
              </div>
              <div ref={calculator}>
                <Calculator calcFormRef={calcFormRef} quoteFormRef={quoteFormRef} QuoteAPI={QuoteAPIFn} quoteJointLife={extraCardFormRef} />
              </div>
            </Background>

            <ErrorBoundary>
              <WhatIs />
            </ErrorBoundary>

            <ErrorBoundary>
              <Recommended />
            </ErrorBoundary>

            <ClaimModal />

            <ErrorBoundary>
              <RetirementGuide />
            </ErrorBoundary>

            <div ref={plan}>
              <ErrorBoundary>
                <PlanWorks calculatorRef={calcFormRef} />
              </ErrorBoundary>
              <VideoModal />
            </div>

            <ErrorBoundary>
              <Glossary />
            </ErrorBoundary>

            <ErrorBoundary>
              <Steps />
            </ErrorBoundary>

            <ErrorBoundary>
              <WhyUsHeader />
            </ErrorBoundary>

            <ErrorBoundary>
              <WhyUs />
            </ErrorBoundary>

            <section ref={faq}>
              <ErrorBoundary>
                <Faq />
              </ErrorBoundary>
            </section>

            <ErrorBoundary>
              <KeyTerms />
            </ErrorBoundary>

            <ErrorBoundary>
              <WhyUsHeader mode={"small"} />
            </ErrorBoundary>

            <Disclaimer data={"main"} />

            <ErrorBoundary>
              <Footer faqRef={faq} planRef={plan} calculatorRef={calculator} />
            </ErrorBoundary>

            <TalkToExpertModal />

            <SuitabilityModal />

            <QuoteModal calcFormRef={calcFormRef} quoteFormRef={quoteFormRef} extraCardFormRef={extraCardFormRef} QuoteAPI={QuoteAPIFn} QUOTEPDFAPI={QUOTEPDFAPI} />

            <AppFormBOO />
          </div>
        )}
      </GlobalProvider>
    </>
  )
})

export default App
